import React, { useState, useEffect, useRef } from 'react';
import Layout from './components/Layout';
import Login from './components/login/Login';
import LoginEntra from './components/login/LoginEntra';
import Home from './components/home/Home';
import Wage from './components/wage/Wage';
import Punch from './components/punch/Punch';
import { Switch, Route } from 'react-router-dom';
import Schedule from './components/prototypeSchedule/Schedule';
import ScheduleAvailability from './components/scheduleAvailability/ScheduleAvailability';
import Survey from './components/survey/Survey';
import BankBalance from './components/bankBalance/BankBalance';
import PayrollRegister from './components/payrollRegister/PayrollRegister';
import MaterialResource from './components/materialResource/MaterialResource';
import ExpenseAccount from './components/expenseAccount/ExpenseAccount';
import Timesheet from './components/timesheet/Timesheet';
import Request from './components/request/Request';
import MyFile from './components/myFile/MyFile';
import Settings from './components/settings/Settings'
import NotFoundPage from './components/customPage/NotFoundPage';
import ErrorPage from './components/customPage/ErrorPage';
import UnauthorizedPage from './components/customPage/UnauthorizedPage';
import { ErrorBoundary } from './components/error/ErrorBoundary'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import logo from "./images/KoneK_logo_2.jpg";
import stylesTitle from './styles/appbarTitle.module.css';
import './custom.css';
import { useLocation } from 'react-router-dom';
import { Worksite } from './utils/users';
import AlertAlgo from './components/controls/AlertSnack';
import withClearCache from "./ClearCache";
import MenuNavigation from './components/menu/MenuNavigation';
import MenuNavigationFavorite from './components/menu/MenuNavigationFavorite';
import InfoLegal from './components/helpOnline/InfoLegal';
import '@progress/kendo-theme-default/dist/all.css';
import * as keyMenu from './scripts/KeyMenu';
import i18next from 'i18next';
import * as MaterialType from './scripts/MaterialResourceTypeMode';
import { getAppConfig } from './utils/config';
import * as storage from './utils/storage';

import { MsalProvider } from '@azure/msal-react';
/*Workaround to the notification - Buffer is not defined*/
import * as buffer from "buffer";
window.Buffer = buffer.Buffer;
/*Workaround to the notification - Buffer is not defined*/

//import { Notifications } from 'react-push-notification';

const ClearCacheComponent = withClearCache(MainApp);

const useStyles = makeStyles(theme => ({
    appBar: {
        top: 'auto',
        bottom: 0,
        height: '35px!important'
    },
    title: {
        flex: 1,
    }
}));

function App({ instance }) {
    return (
        <MsalProvider instance={instance}>
            <ClearCacheComponent />
        </MsalProvider>
    );
}

function MainApp(props) {
    const classes = useStyles();
    const [title, setTitle] = useState('');
    const [logoApp, setLogoApp] = useState(logo);
    const [isOK, setIsOk] = useState(true);
    const [selectedMenu, setSelectedMenu] = useState(keyMenu.MENU_HOME);
    const [showAllMenu, setShowAllMenu] = useState(false);
    const [closeAllMenu, setCloseAllMenu] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [infoLegal, setInfoLegal] = useState(false);
    const [typeInfo, setTypeInfo] = useState('');
    const location = useLocation();
    const alertRef = useRef(null);

    /*isOK is a workaround to not display the title in firefox when we have a worksite validation*/

    useEffect(() => {
        handleShowMenu();
        handlePageWorksite();
        localStorage.removeItem('knkmob.selectedMenu');
    }, []);

    const handleTitleAppBar = (titleApp) => {
        setTitle(titleApp);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const handlePageWorksite = (page = keyMenu.MENU_HOME) => {
        const disallowedPaths = [keyMenu.MENU_PUNCH, keyMenu.MENU_TIMESHEET, keyMenu.MENU_SCHEDULE, keyMenu.MENU_REQUEST, keyMenu.MENU_SCHEDULEAVAILABILITY];
        const worksite = Worksite();
        if (!worksite) {
            if (disallowedPaths.includes(page)) {
                setIsOk(false);
                showMessageError(i18next.t('home:error.message.worksite'));
                setSelectedMenu(keyMenu.MENU_HOME);
            }
        }
    }

    const handleShowMenu = () => {
        setShowMenu(location.pathname === '/');
    }

    const handleShowAllMenu = (show) => {
        setShowAllMenu(show);
        if (!show) {
            setSelectedMenu(localStorage.getItem('knkmob.selectedMenu') ?? keyMenu.MENU_HOME);
        }
    }

    const handleCloseAllMenu = (close) => {
        setCloseAllMenu(close);
    }

    const handleSelectedPage = (menu) => {
        setSelectedMenu(menu);
        handlePageWorksite(menu);
    }

    const handleLegalInfo = (typeInfo) => {
        setInfoLegal(true);
        setShowAllMenu(false);
        setTypeInfo(typeInfo);
    }

    const handleCloseLegalInfo = () => {
        setInfoLegal(false);
    }

    return (
        <div>
            {/*<Notifications />*/}
            <AlertAlgo ref={alertRef} />
            <ErrorBoundary>
                <Switch>
                    <Route path="/login/:error?" component={Login} />
                    <Route path="/loginEntra" component={LoginEntra} />
                    <Layout infoLegal={infoLegal} typeInfo={typeInfo}>
                        <AppBar id="appBarTitle" position="static" className={classes.header}>
                            <Toolbar>
                                <Typography variant="h6" className={classes.title}>
                                    {title !== 'logo' && isOK && title}
                                    {title === 'logo' && <img className={stylesTitle.logoBar} src={logoApp} alt="KoneK Mobile" />}
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <Switch>
                            <Route exact path="/" render={(props) => ""} />
                            <Route path="/error" component={ErrorPage} />
                            <Route path="/unauthorized" component={UnauthorizedPage} />
                            <Route path="*" component={NotFoundPage} />
                        </Switch>

                        {showMenu && selectedMenu == keyMenu.MENU_HOME && <Home onLoadTitle={handleTitleAppBar} handleMessageError={showMessageError} handleSelectedPage={handleSelectedPage} />}
                        {showMenu && selectedMenu == keyMenu.MENU_PAYROLLREGISTER && <PayrollRegister onLoadTitle={handleTitleAppBar}/>}
                        {showMenu && selectedMenu == keyMenu.MENU_DOCUMENTS && <Wage onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_PUNCH && <Punch onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_SCHEDULE && <Schedule onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_EXPENSES && <ExpenseAccount onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_TIMESHEET && <Timesheet onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_REQUEST && <Request onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_PROFILE && <MyFile onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_SCHEDULEAVAILABILITY && <ScheduleAvailability onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_SURVEY && <Survey onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_BANKBALANCE && <BankBalance onLoadTitle={handleTitleAppBar} />}
                        {showMenu && selectedMenu == keyMenu.MENU_MATERIALRESOURCES && <MaterialResource onLoadTitle={handleTitleAppBar} typeMode={MaterialType.Type_Material} />}
                        {showMenu && selectedMenu == keyMenu.MENU_SETTINGS && <Settings onLoadTitle={handleTitleAppBar} onShowAllMenu={() => handleShowAllMenu(true) } />}

                        {showMenu && <MenuNavigationFavorite handleShowAllMenu={handleShowAllMenu} handleSelectedPage={handleSelectedPage} showAllMenu={showAllMenu} selectedMenu={selectedMenu} handleCloseAllMenu={handleCloseAllMenu} />}
                        {showMenu && showAllMenu && <MenuNavigation handleShowAllMenu={handleShowAllMenu} handleSelectedPage={handleSelectedPage} showAllMenu={showAllMenu} closeAllMenu={closeAllMenu} handleLegalInfo={handleLegalInfo} />}
                        <InfoLegal open={infoLegal} handleClose={handleCloseLegalInfo} typeInfo={typeInfo} />
                    </Layout>
                </Switch>
            </ErrorBoundary>
        </div>
    );
}

export default App;